import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';
export default function UIRouterButton(props) {
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: UIButton
  }));
}

const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
      sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);

UIRouterButton.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, {}, clonePropTypes(UIButton));
UIRouterButton.defaultProps = Object.assign({}, cloneDefaultProps(UIButton), {
  use: 'tertiary-light'
});